import type { CourseModule } from "@/core/types";
import { lektionAusfuellen } from "./lektion-01-ausfuellen";
import { lektionRahmen } from "./lektion-02-rahmen";
import { lektionGliederung } from "./lektion-03-gliederung";

/**
 * Werkzeuge der Registerkarten „Start“ und „Daten“, die Tipparbeit sparen.
 * AutoAusfüllen und Blitzvorschau hinterlassen keine Spur und werden am
 * Ergebnis erkannt; die Gliederung kennt nur VBA.
 */
export const modulEffizienz: CourseModule = {
  id: "effizienz",
  title: "Schneller arbeiten: Ausfüllen, Rahmen, Gliederung",
  summary:
    "Reihen ausfüllen, Muster mit der Blitzvorschau erkennen lassen, Rahmenlinien " +
    "gezielt setzen, Zeilen gruppieren und Teilergebnisse je Gruppe einfügen.",
  level: "Grundlagen",
  lessons: [lektionAusfuellen, lektionRahmen, lektionGliederung],
};
